import React from "react";

import UELogo from "../../assets/images/UE.png";

const ContentLogo = () => {
  return <img className="c-content-logo" src={UELogo} alt="Unia Europejska" />;
};

export default ContentLogo;
